import { render, staticRenderFns } from "./ProjectFilterSection.vue?vue&type=template&id=57d89434&scoped=true&"
import script from "./ProjectFilterSection.vue?vue&type=script&lang=js&"
export * from "./ProjectFilterSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFilterSection.vue?vue&type=style&index=0&id=57d89434&lang=scss&scoped=true&"
import style1 from "./ProjectFilterSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d89434",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default})
